<script setup lang="ts">
defineProps<{ name?: string }>()
</script>

<template>
  <div class="min-w-[215px]">
    <div v-if="name" class="mb-2 font-semibold">
      {{ name }}
    </div>
    <div class="flex flex-col gap-1.5 font-normal">
      <slot />
    </div>
  </div>
</template>
